import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./languages/en";
import { vi } from "./languages/vi";

i18n.use(initReactI18next)?.init({
    lng: localStorage?.getItem("laguage") || "vi",
    fallbackLng: localStorage?.getItem("laguage"),
    interpolation: {
        escapeValue: false,
    },
    resources: {
        en: {
            translation: en,
        },
        vi: {
            translation: vi,
        },
    },
});

export default i18n;